var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function newAssignment(data) {
    var instance = {
        __type: "Assignment:#DecisionsFramework.ServiceLayer.Services.Assignments",
        AssignmentId: null,
        ReferenceId: null,
        ValidOnlyInFolderState: null,
        Completed: false,
        IsAssigned: false,
        BringUpOnLogin: false,
        UrlTokens: null,
        NextCheckTime: null,
        NextCheckType: 0 /* AssignmentHandlerEscalationType.None */,
        NextCheckId: null,
        StateChangedDate: null,
        WarnDate: null,
        LateDate: null,
        EscalateDate: null,
        ExpirationDate: null,
        StartDate: null,
        AssignmentInteractionStarted: null,
        AssignmentStarted: null,
        Priority: null,
        Notes: null,
        HandlerData: null,
        FlowTrackingId: null,
        StepTrackingId: null,
        PrimaryFlowId: null,
        PrimaryFlowName: null,
        FlowId: null,
        FlowName: null,
        StepId: null,
        StepName: null,
        CompletedDateTime: null,
        AssignmentTimeInSeconds: 0,
        AssignmentInteractionTimeInSeconds: 0,
        CompletedResult: null,
        CompletedBy: null,
        CompletedNotes: null,
        AssignmentType: null,
        JobScheduleId: null,
        HasStateChanged: null,
        StateChangedBy: null,
        AllAssignments: null,
        AssignmentStartFlowId: null,
        AssignmentWarnFlowId: null,
        AssignmentLateFlowId: null,
        AssignmentEscalteFlowId: null,
        AssignedUsers: null,
        AssignedGroups: null,
        NotificationSubject: null,
        NotificationMessage: null,
        DoNotSendDefaultNotification: false,
        State: null,
        FolderState: null,
        Hidden: false,
        AdministratorViewOnly: false,
        EntityFolderID: null,
        HistoryFolderID: null,
        AllTagsData: null,
        EntityName: null,
        EntityDescription: null,
        CreatedOnDate: new Date('0001-01-01T00:00:00Z'),
        ModifiedDate: new Date('0001-01-01T00:00:00Z'),
        CreatedBy: null,
        ModifiedBy: null,
        Archived: false,
        ArchivedBy: null,
        ArchivedDate: new Date('0001-01-01T00:00:00Z'),
        Deleted: false,
        DeletedBy: null,
        DeletedOn: new Date('0001-01-01T00:00:00Z'),
        CustomLongDescription: null,
        CustomShortDescription: null
    };
    return __assign(__assign({}, instance), data);
}
export function isAssignment(object) {
    return object.__type === "Assignment:#DecisionsFramework.ServiceLayer.Services.Assignments";
}
